import * as d3 from 'd3'
export default {
  methods: {

    form_DataList(selection, props) {

      this.CRT = {id: -1, count: -1}
      let stg = this.stages[props.idx]
      let dataSet = this.rawData.filter(f=> f.STG_IDX==props.idx && f.RELATION==props.target)
      
      let y_ = dataSet.length * 80

      let forms = selection
      .append('g')
      .attr('transform', `translate(0, 0)`)

      forms
      .append('text')
      .attr('x', 20).attr('y', 28).attr('fill', '#000').attr('font-size', 17).attr('font-style', 'italic')
      .text('Input Forms')

      forms.append('text').attr('x', 200).attr('y', 19).attr('fill', '#757575').attr('font-size', 10).attr('font-style', 'italic').attr('text-anchor', 'middle').text('ID')
      forms.append('text').attr('id', `CRT_ID`).attr('x', 200).attr('y', 35).attr('fill', '#000').attr('font-size', 15).attr('text-anchor', 'middle').text(0)

      forms.append('text').attr('x', 250).attr('y', 19).attr('fill', '#757575').attr('font-size', 10).attr('font-style', 'italic').attr('text-anchor', 'middle').text('Count')
      forms.append('text').attr('id', `CRT_COUNT`).attr('x', 250).attr('y', 35).attr('fill', '#000').attr('font-size', 15).attr('text-anchor', 'middle').text(0)

      forms
      .append('image')
      .attr('xlink:href', this.HOST + `/Database/img/PROJECT_${this.config.project}.png`)
      .attr('x', 30).attr('y', 55).attr('width', 167)

      if(props.target=='Input') this.data_Dropdown(forms, this.dataType, {id: `TYPE`,label: 'Data Type', boxWidth: 100, x: 40, y: 115, icon: `TYPE`, verify: 'N'})

      forms
      .append('image')
      .attr('xlink:href', this.HOST + `/Database/icon/Add.svg`)
      .attr('x', props.target == 'Input' ? 150 : 35).attr('y', 120).attr('width', 20).attr('cursor', 'pointer')
      .on('mouseover', function() { d3.select(this).transition().duration(75).style('opacity', .4) })
      .on('mouseout',  function() { d3.select(this).transition().duration(250).style('opacity', 1) })
      .on('click', () => {

        if(this.CRT.count > 5) return

        let type = (props.target=='Input') ? d3.select(`#FORM_TYPE`).text() : '' // In the case of input
        let newData = {
          SEQ: this.CRT.id + 1,
          DIAGRAM: this.config.diagram,
          STG_IDX: stg.STG_IDX,
          STAGE: stg.NAME,
          TYPE: type,
          RELATION: props.target,
          DATABASE: '',
          SCHEMA: '',
          NAME: '',
          FILE_PATH: '',
          EXCEL_SHEET: '',
        }

        if(type == 'Excel') {
          this.draw_ExcelForm(d3.select(`#DATA_LIST`), newData)
        } else {
          this.draw_TableForm(d3.select(`#DATA_LIST`), newData)
        }
        this.reflash(this.CRT) // #####
        y_ += 80

        d3.select(`#DROPDOWN_TYPE`).moveToFront()
      })

      this.gmx_Line(forms, 30, 880, 150, 150, '#E0E0DF', .5, 1)

      // Button Save
      forms 
      .append('image')
      .attr('xlink:href', this.HOST + `/Database/btn/Save.svg`).attr('x', 705).attr('y', 110).attr('width', 80)
      .attr('cursor', 'pointer')
      .on('mouseover', function() {
        d3.select(this).transition().duration(75).style('opacity', .5)
      })
      .on('mouseout', function() {
        d3.select(this).transition().duration(250).style('opacity', 1)
      })
      .on('click', () => {
        this.verify_DataList(forms, props, stg) // -----> APIs.js
      })

      // Button Close
      forms
      .append('image')
      .attr('xlink:href', this.HOST + `/Database/btn/Close.svg`).attr('x', 800).attr('y', 110).attr('width', 80)
      .call(this.call_Closed)

      this.draw_DataList(forms, dataSet)
    },



    draw_DataList(selection, dataSet) {
      let y_ = 0
      let forms = selection
      .append('g')
      .attr('id', 'DATA_LIST')
      .attr('transform', `translate(0, 160)`)

      dataSet.forEach((d,i)=> { 
        if(d.TYPE == 'Excel') {
          this.draw_ExcelForm(forms, d)
        } else {
          this.draw_TableForm(forms, d)
        }

        for (const key in d) {
          d3.select(`#FORM_${key}_${d.SEQ}`).text(d[key])
        }
        y_ += 80
      })
      d3.select(`#DROPDOWN_TYPE`).moveToFront()
    },



    verify_DataList(selection, props, stg) {
      let newDataSet = []
      let dataSet = [
        {code: 'SEQ',         exl: '',  tbl: '',  },
        {code: 'DIAGRAM',     exl: '',  tbl: '',  value: this.config.diagram,},
        {code: 'STG_IDX',     exl: '',  tbl: '',  value: stg.IDX,},
        {code: 'STAGE',       exl: '',  tbl: '',  value: stg.NAME,},
        {code: 'TYPE',        exl: 'Y', tbl: 'Y', },
        {code: 'RELATION',    exl: '',  tbl: '',  value: props.target,},
        {code: 'DATABASE',    exl: '',  tbl: 'Y', },
        {code: 'SCHEMA',      exl: '',  tbl: 'Y', },
        {code: 'NAME',        exl: 'Y', tbl: 'Y', },
        {code: 'FILE_PATH',   exl: 'Y', tbl: '',  },
        {code: 'EXCEL_SHEET', exl: 'Y', tbl: '',  },
      ]
  
      let count = 0
      for(let i=0; i<=this.CRT.id; i++) {

        let data = {}
        if(!d3.select(`#FORM_NAME_${i}`).empty()) {
          dataSet.forEach(d=> {
            if(d.value) {
              data[d.code] = d.value
            } else {
              data[d.code] = d3.select(`#FORM_${d.code}_${i}`).empty() ? '' : d3.select(`#FORM_${d.code}_${i}`).text()
            }
          })
          newDataSet.push(data)
          count++
        }
      }

      // Stroke Color
      let errorCnt = 0
      newDataSet.forEach(d=> {
        if(d.TYPE == 'Excel') {
          // d3.select(`#IFRAME_${d.SEQ}`).attr('stroke', (d.NAME && d.FILE_PATH && d.EXCEL_SHEET) ? '#E0E0DF' : 'red')
          if(!(d.NAME && d.FILE_PATH && d.EXCEL_SHEET)) errorCnt++
        } else {
          // d3.select(`#IFRAME_${d.SEQ}`).attr('stroke', d.TYPE && d.DATABASE && d.SCHEMA && d.NAME ? '#E0E0DF' :'red')
          if(!(d.TYPE && d.DATABASE && d.SCHEMA && d.NAME)) errorCnt++
        }
      })

      // Verification ----------------------------------------------------------
      let message = []

      if(count == 0) message[0] = 'No data has been entered.'
      if(errorCnt>0) message[0] = `Not all ${errorCnt} input fields have been filled in.`
      
      if(message.length > 0) {
        this.open_Popup(selection, props, 'Alert', message)
      } else {
        this.open_Popup(selection, props, 'Confirm', message, newDataSet, stg, props.target)
      }
    },

  }
}